import { render, staticRenderFns } from "./TestimonialAlt.vue?vue&type=template&id=ce250f32&"
import script from "./TestimonialAlt.vue?vue&type=script&lang=js&"
export * from "./TestimonialAlt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports